module.exports = __webpack_public_path__ + "static/media/FyR1o1Wc.c083d7c1.png";